(() => {
  const selector = 'variant-picker.variant-picker--aura';
  document.documentElement.classList.add('crux-aura-pdp-js');

  const namedColors = [
    ['rose gold', '#b76e79'], ['pearl white', '#f6f3ed'], ['hot pink', '#ff3f93'], ['deep pink', '#e96a88'],
    ['light pink', '#f6abc1'], ['bright yellow', '#ffe500'], ['light yellow', '#fff08a'], ['lemon yellow', '#f4dc39'],
    ['light green', '#73e598'], ['olive green', '#708238'], ['emerald green', '#18a66a'], ['aqua green', '#39d7bd'],
    ['light blue', '#8bc8f5'], ['sky blue', '#6ba4ef'], ['deep blue', '#2856b8'], ['ocean blue', '#277eae'],
    ['sapphire blue', '#3565c7'], ['misty blue', '#54d2ed'], ['deep purple', '#7042a2'], ['amethyst purple', '#8d5cc1'],
    ['coral red', '#e8666a'], ['peach pink', '#f19b9e'], ['silver', '#c4c7ce'], ['sliver', '#c4c7ce'],
    ['champagne', '#d9bd8b'], ['magenta', '#d942a6'], ['fuchsia', '#e542b6'], ['turquoise', '#36c7c3'],
    ['lavender', '#ad91dc'], ['violet', '#8157c8'], ['purple', '#a54dcf'], ['indigo', '#4b55a8'],
    ['maroon', '#7b2639'], ['coral', '#ed7b75'], ['orange', '#f29a38'], ['yellow', '#f3d839'],
    ['green', '#36b56a'], ['teal', '#288f91'], ['cyan', '#3bcbd4'], ['aqua', '#49d6d3'],
    ['navy', '#243a6b'], ['blue', '#4b84df'], ['pink', '#ff9cbd'], ['red', '#df4b56'],
    ['brown', '#8b654b'], ['bronze', '#a47745'], ['copper', '#b86f50'], ['gold', '#d1a443'],
    ['grey', '#9fa3aa'], ['gray', '#9fa3aa'], ['black', '#202126'], ['white', '#f7f7f4'],
    ['cream', '#f1e4c8'], ['beige', '#d7c3a4'], ['mint', '#91dfc2'], ['lilac', '#c4a1dd'], ['rose', '#d98791'],
  ];

  const protectedNames = /\b(rainbow dash|pinkie pie|twilight sparkle|applejack|fluttershy|rarity|princess luna|princess celestia|princess cadance|spike|mistmane|sunset shimmer|starlight glimmer|shining armor|trixie)\b/i;

  function nameBasedBackground(value) {
    const text = String(value || '').toLowerCase().replace(/[|｜/_-]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!text || protectedNames.test(text)) return null;
    if (/\b(rainbow|iridescent|aurora borealis|ab coating|multicolor|multi color)\b/.test(text)) {
      return 'linear-gradient(135deg, #ef6c9d 0%, #f1c84b 25%, #65d5bd 50%, #5ca9e8 72%, #9b69cf 100%)';
    }
    const matches = [];
    for (const [name, color] of namedColors) {
      if (
        new RegExp(`\\b${name.replace(/ /g, '\\s+')}\\b`).test(text)
        && !matches.some((item) => item.color === color || item.name.includes(name))
      ) {
        matches.push({ name, color });
      }
    }
    if (!matches.length) return null;
    if (/\bgradient\b/.test(text) || matches.length > 1) {
      return `linear-gradient(135deg, ${matches.slice(0, 3).map((item) => item.color).join(', ')})`;
    }
    return matches[0].color;
  }

  function mapMissingColorSwatches(root = document) {
    root.querySelectorAll(`${selector} .crux-aura-color-option`).forEach((option) => {
      const swatch = option.querySelector('.swatch--unavailable');
      const input = option.querySelector('input');
      if (!swatch || !input) return;
      const background = nameBasedBackground(input.value);
      if (!background) return;
      swatch.style.setProperty('--swatch-background', background);
      swatch.classList.remove('swatch--unavailable');
      swatch.classList.add('swatch--name-mapped');
    });
  }

  function syncPicker(picker) {
    const toggle = picker.querySelector('[data-crux-aura-color-toggle]');
    if (!toggle) return;

    const selectedExtra = picker.querySelector('.crux-aura-color-option--extra input:checked');
    const expanded = picker.dataset.cruxColorsExpanded === 'true' || Boolean(selectedExtra);
    picker.dataset.cruxColorsExpanded = String(expanded);
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? 'SHOW FEWER COLORS' : `VIEW ALL ${toggle.dataset.total} COLORS`;
  }

  function syncAll(root = document) {
    root.querySelectorAll(selector).forEach(syncPicker);
    mapMissingColorSwatches(root);
    syncMobileSelects(root);
  }

  function closeMobileSelect(container) {
    const trigger = container?.querySelector('[data-crux-aura-mobile-select-trigger]');
    const options = container?.querySelector('[data-crux-aura-mobile-select-options]');
    if (!trigger || !options) return;
    trigger.setAttribute('aria-expanded', 'false');
    options.hidden = true;
  }

  function closeOtherMobileSelects(except) {
    document.querySelectorAll(`${selector} .variant-option--dropdowns`).forEach((container) => {
      if (container !== except) closeMobileSelect(container);
    });
  }

  function syncMobileSelects(root = document) {
    root.querySelectorAll('.variant-option--dropdowns').forEach((container) => {
      if (!container.closest(selector)) return;
      const select = container.querySelector('select');
      const value = container.querySelector('[data-crux-aura-mobile-select-value]');
      if (!select || !value) return;
      value.textContent = select.selectedOptions[0]?.textContent?.replace(/\s+/g, ' ').trim() || select.value;
      container.querySelectorAll('[data-crux-aura-mobile-select-option]').forEach((option) => {
        option.setAttribute('aria-selected', String(option.dataset.value === select.value));
      });
    });
  }

  document.addEventListener('click', (event) => {
    const mobileTrigger = event.target.closest('[data-crux-aura-mobile-select-trigger]');
    if (mobileTrigger) {
      const container = mobileTrigger.closest('.variant-option--dropdowns');
      const options = container?.querySelector('[data-crux-aura-mobile-select-options]');
      if (!container || !options) return;
      const willOpen = options.hidden;
      closeOtherMobileSelects(container);
      options.hidden = !willOpen;
      mobileTrigger.setAttribute('aria-expanded', String(willOpen));
      return;
    }

    const mobileOption = event.target.closest('[data-crux-aura-mobile-select-option]');
    if (mobileOption) {
      const container = mobileOption.closest('.variant-option--dropdowns');
      const select = container?.querySelector('select');
      if (!container || !select || mobileOption.disabled) return;
      select.value = mobileOption.dataset.value;
      syncMobileSelects(container);
      closeMobileSelect(container);
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const toggle = event.target.closest('[data-crux-aura-color-toggle]');
    if (!toggle) {
      if (!event.target.closest('.variant-option--dropdowns')) closeOtherMobileSelects(null);
      return;
    }

    const picker = toggle.closest(selector);
    if (!picker) return;

    const expanded = picker.dataset.cruxColorsExpanded === 'true';
    picker.dataset.cruxColorsExpanded = String(!expanded);
    toggle.setAttribute('aria-expanded', String(!expanded));
    toggle.textContent = !expanded ? 'SHOW FEWER COLORS' : `VIEW ALL ${toggle.dataset.total} COLORS`;
  });

  document.addEventListener('change', (event) => {
    const picker = event.target.closest(selector);
    if (picker) {
      syncPicker(picker);
      syncMobileSelects(picker);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeOtherMobileSelects(null);
  });

  document.addEventListener('DOMContentLoaded', () => syncAll());
  document.addEventListener('shopify:section:load', (event) => syncAll(event.target));

  if (document.readyState !== 'loading') syncAll();
})();
